/**
 * Implementation of Http-client wrapper class
 */
import axios from 'axios'
import { baseURL } from './baseURLs'

import store from '@/store/'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// Axios default params.
const defaultParams = { 
  timeout: 10000,
  // withCredentials: true
}

export class HttpClient {
  /**
   * Class constructor
   * Creates axios instance and stores it in private variable.
   * @param {Object} params initial http-client params
   */
  constructor(params = defaultParams) {
    this._http = axios.create(params)
    this._http.interceptors.response.use(
      response => response,
      (error) => {
        const status = error.response ? error.response.status : null
        const data = error.response ? error.response.data : null
  
        if (status === 401 && data==='expired') {
          return store.dispatch('app/refreshToken').then( _ => {
            error.config.headers['Authorization'] = 'Bearer ' + store.getters['app/getAuthTokens'].access_token
            error.config.baseURL = undefined
            return this._http.request(error.config)
          });
        }
        return Promise.reject(error)
      }
    )
  }

  /**
   * Class property getter
   * @returns {object} http-client
   */
  get http() {
    return this._http
  }

  /**
   * Class property getter
   * @returns {string} http-client 'baseURL' property
   */
  get baseURL() {
    return this._http.defaults.baseURL
  }

  /**
   * Class property getter
   * @returns {object} http-client 'config' summary property
   */
  get config() {
    return {
      baseURL: this.http.defaults.baseURL,
      timeout: this.http.defaults.timeout,
      headers: this.http.defaults.headers
    }
  }

  /**
   * Class property setter
   * Sets hppt-client 'baseURL' property
   * @param {String} val new baseURL value
   */
  set baseURL(val) {
    this._http.defaults.baseURL = val
  }

  /**
   * Class property setter
   * Sets hppt-client 'timeout' property 
   * @param {Number} val new timeout value (ms)
   */
  set timeout(val) {
    this._http.defaults.timeout = val
  }

  /**
   * Class property setter
   * Sets hppt-client 'headers' property
   * @param {Object} val new headers value
   */
  set headers(val) {
    // Keep previous header value.
    this._http.defaults.headers = Object.assign({}, this._http.defaults.headers, val)
  }
}

// Create http client instance
const httpClient = new HttpClient(Object.assign({}, defaultParams, { baseURL }))

// Export class definition & its instance.
export default httpClient



// WEBPACK FOOTER //
// ./src/api_module/http-client.js